"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _MobileDropdownHeader = _interopRequireDefault(require("./MobileDropdownHeader"));
var _MobileDropdownOptions = _interopRequireDefault(require("./MobileDropdownOptions"));
var _MobileDropdown = require("./MobileDropdown.proptypes");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var DropDownModal = _styledComponents.default.div.withConfig({
  displayName: "MobileDropdown__DropDownModal",
  componentId: "sc-2qe2b7-0"
})(["position:fixed;display:flex;flex-direction:column;width:100vw;height:100vh;top:0;left:0;background-color:white;z-index:11;& *{box-sizing:border-box;outline:none;}::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;"]);
var SectionTitleContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileDropdown__SectionTitleContainer",
  componentId: "sc-2qe2b7-1"
})(["display:flex;height:32px;padding:", ";align-items:center;background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.small);
}, function (_ref2) {
  var sectionHeaderColor = _ref2.sectionHeaderColor,
    theme = _ref2.theme;
  return theme.backgroundColor[sectionHeaderColor];
});
var OptionsContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileDropdown__OptionsContainer",
  componentId: "sc-2qe2b7-2"
})(["overflow-y:auto;width:100%;height:100%;"]);
var SectionContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileDropdown__SectionContainer",
  componentId: "sc-2qe2b7-3"
})(["padding-bottom:1em;background-color:", ";"], function (_ref3) {
  var backgroundColor = _ref3.backgroundColor,
    theme = _ref3.theme;
  return backgroundColor ? theme.backgroundColor[backgroundColor] : theme.backgroundColor.default;
});
var SectionTitle = function SectionTitle(props) {
  var sectionHeaderLabel = props.sectionHeaderLabel,
    sectionHeaderConfig = props.sectionHeaderConfig,
    theme = props.theme;
  var sectionHeaderColor = sectionHeaderConfig.sectionHeaderColor,
    sectionTitleColor = sectionHeaderConfig.sectionTitleColor;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  return /*#__PURE__*/_react.default.createElement(SectionTitleContainer, {
    sectionHeaderColor: sectionHeaderColor,
    theme: themeContext
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "sub",
    color: sectionTitleColor,
    theme: theme
  }, sectionHeaderLabel));
};
var RenderSection = function RenderSection(props) {
  var sectionConfig = props.sectionConfig,
    markSelectedOnPress = props.markSelectedOnPress,
    selectedItem = props.selectedItem,
    theme = props.theme,
    customProperties = props.customProperties,
    showSectionHeaderLabel = props.showSectionHeaderLabel;
  var _ref4 = sectionConfig || {},
    sectionHeaderLabel = _ref4.sectionHeaderLabel,
    sectionHeaderConfig = _ref4.sectionHeaderConfig,
    sectionColor = _ref4.sectionColor;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var returnSectionHeaderLable = function returnSectionHeaderLable() {
    return /*#__PURE__*/_react.default.createElement(SectionTitle, {
      sectionHeaderLabel: sectionHeaderLabel,
      sectionHeaderConfig: sectionHeaderConfig,
      theme: theme
    });
  };
  return /*#__PURE__*/_react.default.createElement(SectionContainer, (0, _extends2.default)({
    theme: themeContext,
    backgroundColor: sectionColor
  }, customProperties.sections), showSectionHeaderLabel ? returnSectionHeaderLable() : null, /*#__PURE__*/_react.default.createElement(_MobileDropdownOptions.default, (0, _extends2.default)({
    options: sectionConfig.options,
    selectedItem: selectedItem,
    markSelectedOnPress: markSelectedOnPress,
    theme: theme,
    customProperties: customProperties.options
  }, sectionConfig)));
};
var MobileDropdown = function MobileDropdown(props) {
  var headerConfig = props.headerConfig,
    headerLabel = props.headerLabel,
    onHeaderIconClick = props.onHeaderIconClick,
    sections = props.sections,
    defaultSelectedOption = props.defaultSelectedOption,
    theme = props.theme,
    onOptionPress = props.onOptionPress,
    customProperties = props.customProperties,
    showHeader = props.showHeader,
    showSectionHeaderLabel = props.showSectionHeaderLabel,
    idConfig = props.idConfig;
  var _useState = (0, _react.useState)(defaultSelectedOption),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedItem = _useState2[0],
    setSelectedItem = _useState2[1];
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  (0, _react.useEffect)(function () {
    setSelectedItem(defaultSelectedOption);
  }, [defaultSelectedOption]);
  var markSelectedOnPress = function markSelectedOnPress(item) {
    setSelectedItem(item); // To mark the selected item with check icon before invoking the callback function

    setTimeout(function () {
      onOptionPress(item);
    }, 100);
  };
  var returnHeader = function returnHeader() {
    return /*#__PURE__*/_react.default.createElement(_MobileDropdownHeader.default, (0, _extends2.default)({
      idConfig: idConfig,
      label: headerLabel,
      onIconClick: onHeaderIconClick
    }, headerConfig, {
      theme: theme // eslint-disable-next-line react/prop-types
      ,

      customProperties: _objectSpread({
        id: 'mobile-dropdown-header'
      }, customProperties.header)
    }));
  };
  var getMain = function getMain() {
    return /*#__PURE__*/(
      // eslint-disable-next-line react/prop-types
      _react.default.createElement(DropDownModal, (0, _extends2.default)({
        id: "dropdown-modal"
      }, customProperties.dropdown), showHeader ? returnHeader() : null, /*#__PURE__*/_react.default.createElement(OptionsContainer, null,
      // eslint-disable-next-line react/prop-types
      sections.map(function (section) {
        return /*#__PURE__*/_react.default.createElement(RenderSection, {
          sectionConfig: section,
          markSelectedOnPress: markSelectedOnPress,
          theme: theme,
          selectedItem: selectedItem,
          customProperties: customProperties,
          showSectionHeaderLabel: showSectionHeaderLabel
        });
      })))
    );
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
MobileDropdown.propTypes = _MobileDropdown.MobileDropdownPropTypes.PropTypes;
MobileDropdown.defaultProps = _MobileDropdown.MobileDropdownPropTypes.DefaultProps;
RenderSection.propTypes = _MobileDropdown.RenderSectionPropTypes.PropTypes;
SectionTitle.propTypes = _MobileDropdown.SectionTitlePropTypes.PropTypes;
SectionTitle.defaultProps = _MobileDropdown.SectionTitlePropTypes.DefaultProps;
var _default = MobileDropdown;
exports.default = _default;